import {getInitData} from "./helper/getInitData";
import { showRestoreAutosavedFormPromise } from "./helper/Modal/showRestoreAutosavedFormPromise";
import { readAutosaveStorage } from "../../LocalStorage/helpers/AutosaveTransactions/readStorage";
import { select } from "redux-saga/effects";

export function* create(transactionType) {
    let isRestoreForm = false;
    const { data: localStorageData, last_saved } = yield readAutosaveStorage(transactionType) || {};

    // if local storage has an auto-saved copy of that transaction type, prompt modal
    if (localStorageData) {
        const autosaveModalRef = yield select(state => state.Transaction.autosaveModalRef);
        isRestoreForm = yield showRestoreAutosavedFormPromise(transactionType, last_saved, autosaveModalRef); // returns true/false
    }

    return {
        isRestoreForm,
        transaction: isRestoreForm ? localStorageData : yield getInitData(transactionType),
    };
}
